import { getTranslationValue } from '../constants/posMenu';

/**
 * The category the editors show for an item. Menu-map items don't carry their
 * category, so it's the first category whose itemIds include the item.
 * An item can be in several categories; this is the one a category change replaces.
 */
export const getItemCategoryId = (itemId, menuMap) => {
  const item = menuMap?.items?.[itemId];
  if (item?.category || item?.categoryId) {
    return item.category || item.categoryId;
  }
  const found = Object.values(menuMap?.categories || {}).find(
    (cat) => cat.itemIds && cat.itemIds.includes(itemId)
  );
  return found?._id || null;
};

/** The order categories are shown in: by sort, then by name when sorts tie. */
export const sortCategories = (categories) =>
  [...categories].sort((a, b) => {
    const sortDiff = (a.sort || 0) - (b.sort || 0);
    if (sortDiff !== 0) return sortDiff;
    const nameA = getTranslationValue(a.name).toLowerCase();
    const nameB = getTranslationValue(b.name).toLowerCase();
    return nameA.localeCompare(nameB);
  });
